import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isSuccess: false,
  domainData: [],
  error: '',
}

export const getDomainList = createAsyncThunk(
  'domain/getDomainList',
  async (selectedYear, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res = await request(token).get(`/tables/domain`, {
        params: { annee_universitaire: selectedYear },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const deleteDomain = createAsyncThunk(
  'domain/deleteDomain',
  async ({ childrenProps, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res1 = await request(token).delete(`/tables/domain`, {
        data: childrenProps.selected,
      })
      const dt = await res1.data
      toast.success(
        lang === 'Français'
          ? dt?.rowDeleted + ' domaine(s) supprimé(s) avec succès'
          : dt?.rowDeleted + ' domain(s) deleted successfully',
      )
      const res = await request(token).get(`/tables/domain`, {
        params: { annee_universitaire: childrenProps.selectedYear },
      })
      const data = await res.data
      return data
    } catch (err) {
      const message =
        lang === 'Français'
          ? 'Erreur ! ' +
            err.response.data.errorCount +
            ' sur ' +
            childrenProps.selected.length +
            " domaine(s) n'ont pas pu être supprimés"
          : 'Error ! ' +
            err.response.data.message.errorNum +
            ' of ' +
            childrenProps.selected.length +
            ' domain(s) could not be deleted'
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const insertDomain = createAsyncThunk(
  'domain/insertDomain',
  async ({ currentDomain, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res1 = await request(token).post(`/tables/domain`, { data: currentDomain })
      const message =
        lang === 'Français' ? 'Domaine ajouté avec succès' : 'Domain added successfully'
      toast.success(message)
      const res = await request(token).get(`/tables/domain`, {
        params: { annee_universitaire: currentDomain.ANNEE_UNIVERSITAIRE },
      })
      const data = await res.data
      return data
    } catch (err) {
      const message =
        lang === 'Français'
          ? 'Erreur ' + err.response.data.message.errorNum + " ! Le domaine n'a pas pu être ajouté"
          : 'Error ' + err.response.data.message.errorNum + ' ! The domain could not be added'
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const updateDomain = createAsyncThunk(
  'domain/updateDomain',
  async ({ currentDomain, selectedYear, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res1 = await request(token).put(`/tables/domain`, { data: currentDomain })
      const message =
        lang === 'Français'
          ? res1.data.rowUpdated + ' domaine(s) modifié(s) avec succès'
          : res1.data.rowUpdated + ' domain(s) updated successfully'
      toast.success(message)
      const res = await request(token).get(`/tables/domain`, {
        params: {
          annee_universitaire: selectedYear,
          //id_mat: currentCourse.ID_MAT,
        },
      })
      const data = await res.data
      return data
    } catch (err) {
      const message =
        lang === 'Français'
          ? err.response.data.rowUpdated + ' domaine(s) mis à jour avec succès'
          : err.response.data.rowUpdated + ' domain(s) updated successfully'
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const domainSlice = createSlice({
  name: 'domain',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDomainList.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getDomainList.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          domainData: action.payload,
          error: '',
        }
      })
      .addCase(getDomainList.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(insertDomain.pending, (state, action) => {
        return {
          ...state,
        }
      })
      .addCase(insertDomain.fulfilled, (state, action) => {
        return {
          ...state,
          domainData: action.payload,
        }
      })
      .addCase(insertDomain.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          error: action.payload,
        }
      })
      .addCase(updateDomain.pending, (state, action) => {
        return {
          ...state,
        }
      })
      .addCase(updateDomain.fulfilled, (state, action) => {
        return {
          ...state,
          domainData: action.payload,
        }
      })
      .addCase(updateDomain.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          error: action.payload,
        }
      })
      .addCase(deleteDomain.pending, (state, action) => {
        return {
          ...state,
        }
      })
      .addCase(deleteDomain.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccess: true,
          domainData: action.payload,
        }
      })
      .addCase(deleteDomain.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          error: action.payload,
        }
      })
  },
})

export default domainSlice.reducer
